// CSV shape for the hotel export, kept as pure functions so the column set and quoting rules
// are testable without a browser. Both the "this page" and "all pages" exports use these, so
// the two files can never drift apart.

// City and Zone are the geo names (Istanbul / Taksim). There is no Region column: geo has no
// populated level between country and city, and the value that used to fill it WAS the city.
export const CSV_HEADERS = [
  "Hotel Name", "City", "Zone", "Country", "Address", "Stars",
  "Guest Rating", "Reviews", "Phone", "Email", "Status",
];

// One UI hotel (as produced by mapApiHotelToUi) → one CSV row, in CSV_HEADERS order.
// Guest rating is the stored TripAdvisor score on the /10 scale; blank when unrated.
export const hotelToRow = (h) => [
  h.hotelName, h.city, h.zone || "", h.country, h.address,
  h.starRating,
  h.guestRating ? h.guestRating.score10.toFixed(1) : "",
  h.guestRating ? h.guestRating.count : "",
  h.contactPhone, h.contactEmail, h.status,
];

// Quote EVERY cell per RFC-4180 — double any embedded quote — so a hotel name containing a
// comma, quote or newline (they exist) can't shift columns or break rows. A leading UTF-8 BOM
// makes Excel read the file as UTF-8, so accented names ("Málaga", "Cœur") aren't mangled.
export const hotelsToCsv = (rows) =>
  "﻿" +
  [CSV_HEADERS, ...rows.map(hotelToRow)]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
